import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function JourneyBasicComponent({ orderStatus, customers, ShippingStatusId, selectedOrder, onInnerBasicFormChange }: any) {
    return (
        <>
            <AccordionContainer
                child={
                    <><div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Journey Id"
                            name="JourneyId"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'JourneyId'

                                );
                            }}
                            type="number"
                            value={selectedOrder?.JourneyId} />

                        <InputContainer
                            label="ShippingStatus"
                            labelField="Text"
                            list={ShippingStatusId}
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'ShippingStatusId'
                                );
                            }}
                            optionName='Choose NetworkType'
                            type="select"
                            value={selectedOrder?.ShippingStatusId}
                            valueField="Value" />


                        <InputContainer
                            label="Order Status"
                            labelField="Text"
                            list={orderStatus}
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'LogisticsOrderStatusId'
                                );
                            }}
                            optionName='Choose ShippingStatus'
                            type="select"
                            value={selectedOrder?.LogisticsOrderStatusId}
                            valueField="Value" />

                        <InputContainer
                            label="Created On"
                            name="CreatedOnUtc"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'CreatedOnUtc'
                                )
                            }}
                            type="date"
                            value={selectedOrder?.CreatedOnUtc}
                        />
                        <InputContainer
                            label="ModifiedOnUtc"
                            name="ModifiedOnUtc"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'ModifiedOnUtc'
                                )
                            }}
                            type="date"
                            value={selectedOrder?.ModifiedOnUtc}
                        />
                    </div></>
                }
                expandedPanel="basicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}